<script>
    export default {
        name: "scroll-to-me",
        props: {
            slug: {
                type: String,
                default: ''
            },
            debug: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            heightOffset: {
                type: Number,
                default: .25
            },
        },
        watch: {
            disabled: {
                handler() {
                    if (this.disabled) {
                        window.removeEventListener('scroll', this.checkPosition);
                    } else {
                        window.addEventListener('scroll', this.checkPosition);
                        
                        if (document.readyState === 'complete') {
                            this.$nextTick(this.checkPosition);
                        } else {
                            document.addEventListener('readystatechange', this.firstCheck);
                        }
                    }
                },
                immediate: true
            },
        },
        data() {
            return {
                relativeNodes: []
            }
        },
        mounted() {
            this.$nextTick(this.getRelativeNode);
        },
        destroyed() {
            window.removeEventListener('scroll', this.checkPosition);
        },
        methods: {
            firstCheck() {
                if (document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', this.firstCheck);
                    
                    this.checkPosition();
                }
            },
            checkPosition() {
                if (!this.$el || document.readyState !== 'complete') {
                    return;
                }
                
                const windowTop = window.pageYOffset + window.innerHeight * (1 - this.heightOffset);
                let relativeOffset = 0;
                
                this.relativeNodes.forEach((node) => {
                    relativeOffset += node.offsetTop;
                });
                
                if (this.debug) {
                    // console.log(windowTop, this.$el.offsetTop, relativeOffset);
                }
                
                if (windowTop > this.$el.offsetTop + relativeOffset) {
                    this.$emit('trigger-animate', this.slug);
                    
                    window.removeEventListener('scroll', this.checkPosition);
                }
            },
            getRelativeNode() {
                let currentNode = this.$el.parentElement;
                
                while (currentNode !== document.body) {
                    if (window.getComputedStyle(currentNode, null).getPropertyValue('position') === 'relative') {
                        this.relativeNodes.push(currentNode);
                    }
                    
                    currentNode = currentNode.parentElement;
                }
            }
        },
        render() {
            if (!this.$slots.hasOwnProperty('default')) {
                return '';
            }
            
            return this.$slots.default[0];
        }
    }
</script>